import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  IconButton
} from '@mui/material';
import {
  Close,
  Person,
  Edit
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../config/axios';

const ModalFirstAccess = ({ open }) => {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const [isOpen, setIsOpen] = useState(Boolean(open));

  useEffect(() => {
    setIsOpen(Boolean(open));
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    // fai una chiamata ad updateUser per settare isFirstLogin a false
    apiClient.patch('/api/user/update-user', { isFirstLogin: false });
    updateUser({ ...user, isFirstLogin: false });
  };

  const handleEditProfile = () => {
    handleClose();
    navigate('/profile');
  };

  const handleLater = () => {
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return; // Ignore backdrop clicks
        }
        handleClose();
      }}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
          🎉 Benvenuto!
        </Typography>
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            // bgcolor: 'primary.light', 
            borderRadius: 2,
            mb: 3
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Person sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Ciao {user?.name}!
              </Typography>
            </Box>
          </Box>
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            Benvenuto nella nostra piattaforma! <br/>Siamo felici di averti con noi.
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            Per iniziare, ti consigliamo di completare il tuo profilo con tutte le informazioni necessarie.
            Potrai sempre modificare i tuoi dati in seguito.
          </Typography>
          
        </Paper>
      </DialogContent>

      <DialogActions sx={{ 
        p: 3, 
        pt: 1,
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1, sm: 0 }
      }}>
        <Button
          onClick={handleLater}
          variant="outlined"
          sx={{ 
            mr: { xs: 0, sm: 1 },
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          Più tardi
        </Button>
        <Button
          onClick={handleEditProfile}
          variant="contained"
          startIcon={<Edit />}
          sx={{ 
            px: 3,
            py: 1,
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          Modifica Profilo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalFirstAccess;
